import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { AppInformationService, AuthenticationService, UtilityService } from './core/core.module';
import { User } from './core/data/entities';
import { EntityManagerProvider } from './core/data/entity-manager-provider';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    user: User;
    initVersionCheckTimeout;
    environment: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private entityManagerProvider: EntityManagerProvider,
        private auth: AuthenticationService,
        private titleService: Title,
        public appInfo: AppInformationService,
        private utility: UtilityService

    ) {}

    async ngOnInit() {
        this.versionCheck();
        document.addEventListener('initVersionCheck', async () => {
            if (!this.initVersionCheckTimeout) {
                this.versionCheck();
                this.initVersionCheckTimeout = setInterval(this.versionCheck.bind(this), 300000);
            }
        });
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) route = route.firstChild;
                    return route;
                }),
                filter((route) => route.outlet === 'primary'),
                mergeMap((route) => route.data)
            )
            .subscribe((event) => {
                let title = 'RAF Electric';
                if (event['title']) title += ' - ' + event['title'];
                this.titleService.setTitle(title);
                this.appInfo.title = event['title'];
                this.appInfo.hideNav = event['hideNav'];
                const initVersionCheckEvent = new CustomEvent('initVersionCheck');
                document.dispatchEvent(initVersionCheckEvent);
            });

        try {
            if (this.auth.userValue) {
                await this.entityManagerProvider.prepare();
                this.auth.user.subscribe((x) => (this.user = x));
                return;
            }
        } catch (e) {
            console.error(e);
        }
        // this.router.navigate(['/login']);
    }

    async versionCheck() {
        const currentUser = await this.auth.userValue;
        if (!currentUser) {
            this.appInfo.versionWarning = null;
            return;
        }
        const serviceVersion = await this.utility.getServiceVersion();
        const clientVersion = this.appInfo.clientVersion;
        if (this.appInfo.serviceVersion !== serviceVersion) this.appInfo.serviceVersion = serviceVersion;
        if (!serviceVersion || !clientVersion) this.appInfo.versionWarning = 'Unknown version information';
        else if (serviceVersion !== clientVersion) {
            this.appInfo.versionWarning = 'New Version Available - Save ALL Changes, then Refresh Browser (Crtl + F5) For Latest Update';
        } else this.appInfo.versionWarning = null;
    }
}
